import React, { useContext } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AdminSidebar from './AdminSidebar';
import MainContext from '../../store/MainContext';
import { isMobile } from 'react-device-detect';

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
  },
}));

const AdminDrawer = (props) => {
  const { open, onClose } = props;
  const classes = useStyles();
  const theme = useTheme();
  const { state, dispatch, showMessage } = useContext(MainContext);
  const { appName, appLogo } = state.Public;
  const handleCloseDrawer = () => {
    onClose();
  };
  return (
    <Drawer
      className={classes.drawer}
      anchor="left"
      open={open}
      classes={{
        paper: classes.drawerPaper,
      }}
      {...props}
    >
      <div className={classes.drawerHeader}>
        <div style={{ textAlign: 'center', flexGrow: 1 }}>
          {isMobile ? (
            <h1 style={{ fontSize: 18 }}>{appName}</h1>
          ) : (
            <img src={appLogo} alt={appName} width={32} height={32} />
          )}
        </div>
        <IconButton onClick={handleCloseDrawer}>
          {theme.direction === 'ltr' ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
      </div>
      <Divider />
      <AdminSidebar onClose={handleCloseDrawer} />
    </Drawer>
  );
};

export default AdminDrawer;
